import { all } from "redux-saga/effects";
import watchLoginDetail from "../common/login/loginSaga";
import watchApplicationData from "../common/getApplicationData/getApplicationDataSaga";
import PartnerFilesagas from "../../../components/partnerFileUpload/redux/partnerFileUploadSaga";
import userManagementSaga from "../../../components/UserManagement/redux/userManagementSaga";
import deploymentSchedulerSaga from "../../../components/deployment-scheduler/redux/deploymentSchedulerSaga";
// Gold counts watcher is now part of PartnerFilesagas

function* rootSaga() {
  yield all([
    watchLoginDetail(),
    watchApplicationData(),
    PartnerFilesagas?.watchUtilityData(),
    PartnerFilesagas?.watchAdminEngagementData(),
    PartnerFilesagas?.watchAdminFilesData(),
    PartnerFilesagas?.watchFilesEngagementData(),
    PartnerFilesagas?.watchPartnerFilesBlocklistData(),
    PartnerFilesagas?.watchPartnersEditEngagementDetails(),
    PartnerFilesagas?.watchPartnersFileValidation(),
    PartnerFilesagas?.watchPartnersFilesDelete(),
    PartnerFilesagas?.watchPartnersViewFilesContent(),
    PartnerFilesagas?.watchPartnersDeleteTempFilesOnPopupClose(),
    PartnerFilesagas?.watchPartnersFilesDownload(),
    PartnerFilesagas?.watchPartnersEditEngagementStatus(),
    PartnerFilesagas?.watchPartnersSasToken(),
    PartnerFilesagas?.watchPartnersUploadProcessing(),
    PartnerFilesagas?.watchPartnersUploadReProcessing(),
    PartnerFilesagas?.watchPartnersUploadSharePointFilesToBlob(),
    PartnerFilesagas?.watchPartnersAccessGrant(),
    PartnerFilesagas?.watchPartnersAccessRevoke(),
    PartnerFilesagas?.watchSingleUploadCount(),
  PartnerFilesagas?.watchAdminOriginalFileNamesData(),
  PartnerFilesagas?.watchAdminStartAnonymizationData(),
    PartnerFilesagas?.watchAdminDownloadFile(),
    PartnerFilesagas?.watchAdminExportExcel(),
  PartnerFilesagas?.watchAdminUploadFile(),
  userManagementSaga(),
  deploymentSchedulerSaga(),
  PartnerFilesagas?.watchAdminGoldCounts(),
  PartnerFilesagas?.watchAdminBookmarkFile(),
  PartnerFilesagas?.watchPartnersUploadedFileStatus(),
  PartnerFilesagas?.watchPartnersDuplicateFiles(),
  PartnerFilesagas?.watchPartnersEnableDisableClientData(),
  PartnerFilesagas?.watchPartnersSaveErrorData(),
  PartnerFilesagas?.watchPlannedOutagePrior(),
  PartnerFilesagas?.watchPlannedOutageActive(),
  PartnerFilesagas?.watchPartnersDownloadArcArchives(),
  ]);
}

export default rootSaga;
